import Call from './call'

const cards = {
  call: { component: Call }
}

export default cards
